import React, { useState } from "react";
import CardSlide from "../Slider/card_slide";

const BestSellerAndNewarrivel = () => {
  const bestSellerData = [
    {
      id: 1,
      price: "$182.00",
      cate: "SkinCeuticals C E Ferulic (1 fl. oz.)",
      img: "https://static.thcdn.com/images/small/webp//productimg/original/11289609-1995037121294344.jpg",
      label: "Wicked Lady",
    },
    {
      id: 2,
      price: "230000 MMK",
      cate: "Jack And Gina Zinfandel Rose Wine 75cl",
      img: "https://static.thcdn.com/images/small/webp//productimg/original/11582506-6064978637869764.jpg",
      label: "Jack And Gina",
    },
    {
      id: 3,
      price: "260000 MMK",
      cate: "Selladore En Provence Rose Wine 2022 75cl",
      img: "https://static.thcdn.com/images/small/webp//productimg/original/13547804-3064932747510939.jpg",
      label: "William Chase",
    },
    {
      id: 4,
      price: "300000 MMK",
      cate: "Chateau d'Esclans Whispering Angel Rose Wine 2022 75cl",
      img: "  https://static.thcdn.com/images/small/webp//productimg/original/14018243-9275043599035689.jpg",
      label: "Chateau d'Esclans",
    },
    {
      id: 5,
      price: "something",
      cate: "recom",
      img: "https://static.thcdn.com/images/small/webp//productimg/original/11290635-2054892767941057.jpg",
    },
  ];
  const newArrivelData = [
    {
      id: 1,
      price: "$182.00",
      cate: "SkinCeuticals C E Ferulic (1 fl. oz.)",
      img: "https://static.thcdn.com/images/small/webp//productimg/original/11289609-1995037121294344.jpg",
      label: "Wicked Lady",
    },
    {
      id: 2,
      price: "230000 MMK",
      cate: "Jack And Gina Zinfandel Rose Wine 75cl",
      img: "https://static.thcdn.com/images/small/webp//productimg/original/11582506-6064978637869764.jpg",
      label: "Jack And Gina",
    },
    {
      id: 3,
      price: "260000 MMK",
      cate: "Selladore En Provence Rose Wine 2022 75cl",
      img: "https://static.thcdn.com/images/small/webp//productimg/original/13547804-3064932747510939.jpg",
      label: "William Chase",
    },
    {
      id: 4,
      price: "300000 MMK",
      cate: "Chateau d'Esclans Whispering Angel Rose Wine 2022 75cl",
      img: "  https://static.thcdn.com/images/small/webp//productimg/original/14018243-9275043599035689.jpg",
      label: "Chateau d'Esclans",
    },
    {
      id: 5,
      price: "something",
      cate: "recom",
      img: "https://static.thcdn.com/images/small/webp//productimg/original/11290635-2054892767941057.jpg",
    },
  ];
  const [active, setActive] = useState(0);
  const handleActive = (click) => {
    setActive(click);
  };
  return (
    <div className="mt-10">
      <div className="flex justify-center ">
        <a
          onClick={() => handleActive(0)}
          className={`${
            active == 0
              ? "border-b-2 border-b-black px-2 cursor-pointer"
              : " cursor-pointer  border-b-2 px-2"
          }`}
        >
          {" "}
          best seller
        </a>
        <a
          onClick={() => handleActive(1)}
          className={`${
            active == 1
              ? "border-b-2 border-b-black px-2 cursor-pointer"
              : " cursor-pointer border-b-2 px-2"
          }`}
        >
          {" "}
          new Arrivals
        </a>
      </div>
      <div>{active == 0 && <CardSlide SlideData={bestSellerData} />}</div>
      <div>{active == 1 && <CardSlide SlideData={newArrivelData} />}</div>
    </div>
  );
};

export default BestSellerAndNewarrivel;
